import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Warning from "../../images/warning.svg";
import Question from "../../images/icons/question.svg";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import {
  Button,
  FormHelperText,
  MenuItem,
  Modal,
  TextField,
} from "@material-ui/core";
import TitleCase from "react-title-case";
import { REQUIRED_MESSAGE } from "../../constants";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 350,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  accept: {
    background: "#E5E5E5",
    color: "#7EBDCE",
    marginRight: "5%",
    "&:hover": {
      background: "#E5E5E5",
    },
  },
  cancel: {
    background: "#7EBDCE",
    color: "white",
    "&:hover": {
      background: "#7EBDCE",
    },
  },
  text: {
    fontSize: 15,
    fontFamily: "Roboto",
    color: "#545353",
    textAlign: "center",
    margin: "20px 20px",
  },
  titleAlert: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#545353",
  },
}));

const ModalConfirmBaseComment = ({
  description,
  open,
  handleClick,
  handleClickOut,
  type,
  title,
  oneButtons,
  textButtonSubmit,
  option,
}) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [selected, setSelected] = useState("");
  const [isRequired, setIsRequired] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [comm, setComm] = useState("");
  const [invalidMin, setInvalidMin] = useState(false);
  const [invalidMax, setInvalidMax] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setTimeout(() => {
      setShowComment(false);
      setComm("");
      setSelected("");
    }, 200);
  }, []);

  const setComentarios = (p) => {
    let largo = p.target.value.length;
    if (largo < 20) {
      setInvalidMin(true);
      setErrorMessage("Ingrese mínimo 20 caracteres");
    } else if (largo >= 20 && largo <= 200) {
      setInvalidMin(false);
      setInvalidMax(false);
      setErrorMessage("");
    } else if (largo > 200) {
      setInvalidMax(true);
      setErrorMessage("Ingrese máximo 200 caracteres");
    }

    setComm(p.target.value);
  };

  const isValid = () => {
    let largo = comm.length;
    if (largo < 20) {
      setInvalidMin(true);
      setErrorMessage("Ingrese mínimo 20 caracteres");
    } else if (largo >= 20 && largo <= 200) {
      setInvalidMin(false);
      setInvalidMax(false);
      setErrorMessage("");
    } else if (largo > 200) {
      setInvalidMax(true);
      setErrorMessage("Ingrese máximo 200 caracteres");
    }
    if (largo < 20 || largo > 200) {
      return false;
    } else {
      return true;
    }
  };

  const onAcceptButton = () => {
    let observation = showComment ? comm : selected;
    let motivoText = selected;
    if (!selected) {
      setIsRequired(true);
      return;
    }
    if (showComment) {
      let isValidComment = isValid();
      if (!isValidComment) {
        return;
      }
      setSelected("");
      handleClick({ motivoText, observation });
    } else {
      setSelected("");
      handleClick({ motivoText, observation });
    }
  };

  const onSelectChange = (e) => {
    const { value } = e.target;
    setIsRequired(value ? false : true);
    if (value === "CANCELACION_SOLICITUD") {
      setShowComment(true);
    } else {
      setShowComment(false);
      setComm("");
    }
  };

  const onHandleClickOut = () => {
    setShowComment(false);
    setComm("");
    setSelected("");
    handleClickOut();
    setIsRequired(false);
  };

  const iconsAlert = (type) => {
    if (type === "WARNING")
      return <img src={Warning} alt="" style={{ width: "30%" }} />;
    if (type === "QUESTION")
      return <img src={Question} alt="" style={{ width: "30%" }} />;
    if (type === "SUCCESS")
      return (
        <CheckCircleOutlineOutlinedIcon
          style={{ width: "45%", color: "green", height: "30%" }}
        />
      );
  };

  const renderButtons = (
    oneButtons,
    textButtonSubmit,
    handleClick,
    handleClickOut
  ) => {
    if (oneButtons) {
      return (
        <Button
          className={classes.cancel}
          type="button"
          variant="contained"
          color="secondary"
          onClick={onAcceptButton}
        >
          {textButtonSubmit ? textButtonSubmit : "Aceptar"}
        </Button>
      );
    } else {
      return (
        <>
          <Button
            className={classes.accept}
            type="button"
            variant="contained"
            onClick={onHandleClickOut}
          >
            Cancelar
          </Button>

          <Button
            className={classes.cancel}
            type={oneButtons ? "button" : "submit"}
            variant="contained"
            color="secondary"
            onClick={onAcceptButton}
          >
            {textButtonSubmit ? textButtonSubmit : "Aceptar"}
          </Button>
        </>
      );
    }
  };

  const bodyModal = (
    <div style={modalStyle} className={classes.paper}>
      {iconsAlert(type)}
      {title ? <h1 className={classes.titleAlert}> {title} </h1> : null}
      <p className={classes.text}>{description}</p>
      <TextField
        fullWidth
        size="small"
        name="selected"
        id="outlined-select-currency"
        select
        label={option?.name}
        onChange={(e) => {
          setSelected(e.target.value);
          onSelectChange(e);
        }}
        variant="outlined"
        style={{ marginTop: "15px" }}
      >
        {option?.data.map((op) => (
          <MenuItem
            className={classes.menuItem}
            key={op[option?.key]}
            value={op[option?.key]}
          >
            <TitleCase string={op[option?.value]} />
          </MenuItem>
        ))}
      </TextField>
      <FormHelperText style={{ color: "#f44336", marginBottom: "15px" }}>
        {isRequired && REQUIRED_MESSAGE}
      </FormHelperText>

      {showComment && (
        <>
          <TextField
            autoFocus
            fullWidth
            variant="outlined"
            id="comments"
            name="comments"
            label="Observación"
            multiline
            rows={4}
            rowsMax={4}
            onChange={setComentarios}
            type="text"
          />
          <FormHelperText style={{ color: "#f44336", marginBottom: "20px" }}>
            {errorMessage}
          </FormHelperText>
        </>
      )}
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}
      >
        {renderButtons(oneButtons, textButtonSubmit, handleClick)}
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        style={{ textAlign: "center" }}
        open={open}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {bodyModal}
      </Modal>
    </div>
  );
};

export default ModalConfirmBaseComment;
